import { noop } from 'lodash';
import { createContext, type RefObject, useContext } from 'react';
import type { ErrorMessage } from '@/views/NewInteraction/types';
import type { ClientGroup } from '../types';

export type CreateOfferContextType = {
  updateContext: (context: Partial<CreateOfferContextType>) => void;
  errorMessage?: ErrorMessage;
  sourceId?: string;
  buyerId?: string;
  step: number;
  formContainerRef?: RefObject<HTMLDivElement | null>;
  defaultBuyer?: ClientGroup;
  defaultBuyerLoading: boolean;
  openedFromListing?: boolean;
  linkSource?: 'dropdown' | 'modal' | 'lom';
};

export const CREATE_OFFER_CONTEXT_DEFAULTS: CreateOfferContextType = {
  updateContext: noop,
  step: 0,
  defaultBuyerLoading: false,
};

export const CreateOfferContext = createContext<CreateOfferContextType>(
  CREATE_OFFER_CONTEXT_DEFAULTS,
);

export function useCreateOfferContext() {
  return useContext(CreateOfferContext);
}
